module.exports = __webpack_public_path__ + "static/partner-cdbc9a004b178b45f88e56b2eda0be20.png";